import { FunctionComponent, h } from 'preact'

export const AppContainer: FunctionComponent = ({ children }) => {
  return <main className="app-container">{children}</main>
}
